import getStateValue from '../../helpers/getStateValue';
import { convertSrcToCorrect } from '../../../helper/urls';
import { NO_SRC } from '../../../helper/urls/constants';

const staticApi = getStateValue('apiUrls', {});
const defaultImage = convertSrcToCorrect(NO_SRC, staticApi);

export default defaultImage;
